function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import { Button } from '@progress/kendo-react-buttons';
import ServiceFactory from '../../service';
import __JSONbigFactory from 'json-bigint';
var JSONbigString = __JSONbigFactory({
  storeAsString: true
});
import Auth from "../../functions/authenticate";
import { parseCompanyData, sentimentWords, readableDate, hostOf, realCompetitors } from "./company-detail";

/*
 * Company Analysis list (apps redesign 2026-10-09, board 2).
 * Header + one card: pills (All / Yours / Competitors), search, and a
 * clean table (Company, Competitors found, How people talk about it,
 * Analyzed, "···" menu with Open and Delete behind an inline confirm).
 * Rows still running show a Running chip and the list polls until they
 * finish.
 *
 * New-analysis form: a two-step modal. Resolve the company from a URL
 * first (identity card before a multi-minute run; resolve failure keeps
 * the form usable with a free-text name), then optional focus markets
 * and suggested competitors (unchecked by default; checked ones ride the
 * submit as `competitors[]`).
 */

export const rowId = row => {
  try {
    return String(JSONbigString.parse(String(row.id)));
  } catch (e) {
    return String(row.id);
  }
};
export const isDone = row => /completed/i.test(String(row.status || ""));
export const isFailed = row => /fail|error/i.test(String(row.status || ""));

/**
 * Shared list card for the research apps: pills, search, table, row menu.
 * head = [{ label, cls }], rows = [{ id, cells: [node], open: fn|null }].
 */
export class AprListCard extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onDocClick", e => {
      if (this.state.menu && !(e.target.closest && e.target.closest(".apr-menu-wrap"))) this.setState({
        menu: null,
        confirm: null
      });
    });
    _defineProperty(this, "del", id => {
      this.setState({
        deleting: id
      });
      this.props.onDelete(id, () => this.setState({
        deleting: null,
        menu: null,
        confirm: null
      }));
    });
    this.state = {
      menu: null,
      confirm: null,
      deleting: null,
      limit: 25
    };
  }
  componentDidMount() {
    document.addEventListener("click", this.onDocClick);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.onDocClick);
  }
  render() {
    const {
      pills,
      pill,
      onPill,
      search,
      onSearch,
      placeholder,
      head,
      rows,
      empty
    } = this.props;
    const {
      menu,
      confirm,
      deleting,
      limit
    } = this.state;
    const visible = rows.slice(0, limit);
    return /*#__PURE__*/React.createElement("section", {
      className: "apr-card apr-list"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apr-toolbar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apr-pills"
    }, pills.map(p => /*#__PURE__*/React.createElement("button", {
      key: p.k,
      type: "button",
      className: "apr-pill" + (pill === p.k ? " on" : ""),
      onClick: () => onPill(p.k)
    }, p.label, " ", p.count))), /*#__PURE__*/React.createElement("input", {
      className: "apr-search",
      type: "search",
      value: search,
      placeholder: placeholder,
      onChange: e => onSearch(e.target.value)
    })), /*#__PURE__*/React.createElement("div", {
      className: "apr-table-wrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "apr-table apr-list-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, head.map((h, i) => /*#__PURE__*/React.createElement("th", {
      key: i,
      className: h.cls || ""
    }, h.label)), /*#__PURE__*/React.createElement("th", {
      className: "apr-menu-col"
    }))), /*#__PURE__*/React.createElement("tbody", null, visible.map(r => /*#__PURE__*/React.createElement("tr", {
      key: r.id,
      className: r.open ? "apr-clickable" : "",
      onClick: e => {
        if (r.open && !(e.target.closest && e.target.closest(".apr-menu-wrap, a"))) r.open();
      }
    }, r.cells.map((c, i) => /*#__PURE__*/React.createElement("td", {
      key: i,
      className: head[i] && head[i].cls || ""
    }, c)), /*#__PURE__*/React.createElement("td", {
      className: "apr-menu-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apr-menu-wrap"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "apr-dots",
      "aria-label": "More actions",
      onClick: () => this.setState({
        menu: menu === r.id ? null : r.id,
        confirm: null
      })
    }, "\xB7\xB7\xB7"), menu === r.id ? /*#__PURE__*/React.createElement("div", {
      className: "apr-menu"
    }, confirm === r.id ? /*#__PURE__*/React.createElement("div", {
      className: "apr-confirm"
    }, /*#__PURE__*/React.createElement("span", null, "Delete this report?"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "apr-danger",
      disabled: deleting === r.id,
      onClick: () => this.del(r.id)
    }, deleting === r.id ? "Deleting…" : "Delete"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => this.setState({
        confirm: null
      })
    }, "Cancel"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      disabled: !r.open,
      onClick: () => {
        this.setState({
          menu: null
        });
        r.open && r.open();
      }
    }, "Open"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => this.setState({
        confirm: r.id
      })
    }, "Delete"))) : null))))))), !rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "apr-empty"
    }, empty) : null, rows.length > limit ? /*#__PURE__*/React.createElement("div", {
      className: "apr-more"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        limit: limit + 25
      })
    }, "Show more")) : null);
  }
}
export const StatusChip = ({
  row
}) => isFailed(row) ? /*#__PURE__*/React.createElement("span", {
  className: "apr-chip apr-chip-failed"
}, "Failed") : /*#__PURE__*/React.createElement("span", {
  className: "apr-chip apr-chip-running"
}, "Running");
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "refreshRows", async () => {
      try {
        const rows = await this.svc('/company-analysis').getAsync();
        const list = Array.isArray(rows) ? rows : rows.items || [];
        if (this._alive) this.setState({
          rows: list
        }, () => this.ensurePolling());
      } catch (e) {/* keep polling */}
    });
    _defineProperty(this, "resolve", async () => {
      const url = this.state.url.trim();
      if (!url || this.state.resolving) return;
      this.setState({
        resolving: true,
        resolved: null,
        resolveFailed: false,
        suggestions: null
      });
      try {
        const results = await new Promise((res, rej) => this.svc('/company-analysis/search').post({
          url
        }, (err, data) => err ? rej(err) : res(data)));
        const first = (Array.isArray(results) ? results : [])[0];
        if (!first) throw new window.Error('no results');
        // Identity from the top result: pick the title segment that best
        // matches the domain base; the name field stays editable either way.
        const base = hostOf(url).split('.')[0].toLowerCase();
        const segs = String(first.title || '').split(/::|\||–|- /).map(x => x.trim()).filter(Boolean);
        let name = segs.find(x => x.toLowerCase().replace(/[^a-z]/g, '').includes(base)) || segs[0] || hostOf(url);
        name = name.replace(/\s*\([A-Z.]{1,6}\)\s*$/, '').trim(); // drop ticker suffixes "(ABC)"
        // Description: first real sentence (8+ words); a junk description is worse than none.
        const sentences = String(first.text || '').replace(/[#*]+/g, ' ').split(/[\n.]+/).map(x => x.replace(/\s+/g, ' ').trim());
        const desc = sentences.find(x => x.split(' ').length >= 8) || '';
        if (!this._alive) return;
        this.setState({
          resolving: false,
          resolved: {
            name,
            desc
          },
          company: this.state.company || name
        });
        this.loadSuggestions(url);
      } catch (e) {
        if (this._alive) this.setState({
          resolving: false,
          resolveFailed: true
        });
      }
    });
    _defineProperty(this, "submit", () => {
      const {
        url,
        company,
        markets,
        suggestions,
        submitting
      } = this.state;
      if (!url.trim() || !company.trim() || submitting) return;
      const auth = Auth.get() || {};
      const competitors = (suggestions || []).filter(c => c.checked).map(c => c.domain);
      this.setState({
        submitting: true
      });
      this.svc('/company-analysis').post({
        url: url.trim(),
        company: company.trim(),
        locations: markets,
        userId: auth.email || '',
        ...(competitors.length ? {
          competitors
        } : {})
      }, err => {
        if (!this._alive) return;
        if (err) {
          this.setState({
            submitting: false,
            running: {
              company: company.trim(),
              failed: true
            }
          });
          return;
        }
        const startedAt = Date.now();
        this.setState({
          modal: false,
          submitting: false,
          url: "",
          company: "",
          resolved: null,
          resolveFailed: false,
          markets: [],
          suggestions: null,
          running: {
            company: company.trim(),
            startedAt,
            elapsed: 0
          }
        });
        this._tick = setInterval(() => {
          if (this.state.running && this.state.running.startedAt) {
            this.setState({
              running: {
                ...this.state.running,
                elapsed: Math.floor((Date.now() - startedAt) / 1000)
              }
            });
          }
        }, 1000);
        this._poll = setInterval(this.checkRun(company.trim()), 10000);
        this.refreshRows();
      });
    });
    _defineProperty(this, "checkRun", company => async () => {
      try {
        const rows = await this.svc('/company-analysis').getAsync();
        const list = Array.isArray(rows) ? rows : rows.items || [];
        if (this._alive) this.setState({
          rows: list
        });
        const mine = list.filter(r => String(r.company).toLowerCase() === company.toLowerCase()).sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))[0];
        if (!mine || !this._alive) return;
        if (isDone(mine)) {
          clearInterval(this._tick);
          clearInterval(this._poll);
          this.setState({
            running: {
              company,
              reportId: rowId(mine)
            }
          });
        } else if (isFailed(mine)) {
          clearInterval(this._tick);
          clearInterval(this._poll);
          this.setState({
            running: {
              company,
              failed: true
            }
          });
        }
      } catch (e) {/* keep polling */}
    });
    _defineProperty(this, "toggleMarket", m => () => {
      this.setState({
        markets: this.state.markets.includes(m) ? this.state.markets.filter(x => x !== m) : [...this.state.markets, m]
      });
    });
    _defineProperty(this, "onDelete", (id, done) => {
      this.svc('/company-analysis').delete(id, err => {
        if (!this._alive) return;
        done();
        if (!err) this.setState({
          rows: this.state.rows.filter(r => rowId(r) !== id)
        });
      });
    });
    this.state = {
      rows: props.data || [],
      pill: "all",
      search: "",
      modal: false,
      url: "",
      company: "",
      resolving: false,
      resolved: null,
      // { name, desc } | null
      resolveFailed: false,
      markets: [],
      marketInput: "",
      marketOptions: [],
      suggestions: null,
      // [{ domain, checked }] | null (loading), set after resolve
      submitting: false,
      running: null // { company, startedAt, elapsed, reportId, failed }
    };
    this._alive = true;
  }
  componentDidMount() {
    publishSearch('Research');
    publishEvent('reset-search', {});
    // Focus-market chip options = the tenant's managed markets (fail-soft;
    // tenants without locations just use free-text adds).
    try {
      const Service = ServiceFactory.getType('/location', 'location');
      new Service().getAsync().then(rows => {
        const list = Array.isArray(rows) ? rows : rows && rows.items || [];
        if (this._alive) this.setState({
          marketOptions: [...new Set(list.map(l => l.name).filter(Boolean))].slice(0, 8)
        });
      }).catch(() => {});
    } catch (e) {/* none */}
    this.ensurePolling();
  }
  componentWillUnmount() {
    this._alive = false;
    clearInterval(this._tick);
    clearInterval(this._poll);
    clearInterval(this._listPoll);
  }
  svc(api) {
    const Service = ServiceFactory.getType(api, 'research');
    return new Service();
  }

  // Poll the list while any row is still running.
  ensurePolling() {
    const anyRunning = this.state.rows.some(r => !isDone(r) && !isFailed(r));
    if (anyRunning && !this._listPoll) this._listPoll = setInterval(this.refreshRows, 10000);
    if (!anyRunning && this._listPoll) {
      clearInterval(this._listPoll);
      this._listPoll = null;
    }
  }
  loadSuggestions(url) {
    this.setState({
      suggestions: []
    });
    this.svc('/company-analysis/similar').post({
      url,
      maxResults: 8
    }, (err, data) => {
      if (err || !this._alive) return;
      // Own-domain filter by suffix; suggestions default unchecked
      // because the endpoint returns noise alongside real competitors.
      const own = hostOf(url);
      const domains = [];
      (Array.isArray(data) ? data : []).forEach(r => {
        const h = hostOf(r.url || r.id || '');
        if (h && h !== own && !h.endsWith('.' + own) && !domains.includes(h)) domains.push(h);
      });
      this.setState({
        suggestions: domains.slice(0, 6).map(domain => ({
          domain,
          checked: false
        }))
      });
    });
  }
  renderRunStrip() {
    const r = this.state.running;
    if (!r) return null;
    const stop = () => {
      clearInterval(this._tick);
      clearInterval(this._poll);
      this.setState({
        running: null
      });
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "apr-strip"
    }, r.reportId ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "apr-dot ok"
    }), /*#__PURE__*/React.createElement("span", null, "The ", r.company, " analysis is ready."), /*#__PURE__*/React.createElement("a", {
      onClick: () => this.props.history.push(`/Research/Company/Detail/${r.reportId}`)
    }, "Open it")) : r.failed ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "apr-dot bad"
    }), /*#__PURE__*/React.createElement("span", null, "The ", r.company, " analysis did not finish. Try again with Analyze a company.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "apr-spinner"
    }), /*#__PURE__*/React.createElement("span", null, "Analyzing ", r.company, "\u2026 ", r.elapsed ? `${Math.floor(r.elapsed / 60)}:${String(r.elapsed % 60).padStart(2, "0")}` : ""), /*#__PURE__*/React.createElement("span", {
      className: "apr-muted"
    }, "takes 2 to 3 minutes")), /*#__PURE__*/React.createElement("a", {
      className: "apr-muted apr-dismiss",
      onClick: stop
    }, "Dismiss"));
  }
  renderModal() {
    if (!this.state.modal) return null;
    const {
      url,
      company,
      resolving,
      resolved,
      resolveFailed,
      markets,
      marketInput,
      marketOptions,
      suggestions,
      submitting
    } = this.state;
    const inp = {
      width: "100%",
      padding: "8px 10px",
      border: "1px solid var(--plk-border)",
      borderRadius: "6px",
      fontSize: "13px",
      background: "var(--plk-surface, #fff)"
    };
    const lbl = {
      display: "block",
      fontSize: "10.5px",
      textTransform: "uppercase",
      letterSpacing: ".06em",
      color: "var(--plk-text-dim)",
      fontWeight: 600,
      marginBottom: "3px"
    };
    const marketChips = [...new Set([...marketOptions, ...markets])];
    return /*#__PURE__*/React.createElement("div", {
      className: "mtf-overlay",
      onClick: () => !submitting && this.setState({
        modal: false
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "mtf-modal",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "mtf-head"
    }, /*#__PURE__*/React.createElement("h2", null, "Analyze a company"), /*#__PURE__*/React.createElement("a", {
      onClick: () => this.setState({
        modal: false
      }),
      className: "mtf-dim",
      style: {
        cursor: "pointer"
      }
    }, "\u2715")), /*#__PURE__*/React.createElement("div", {
      className: "mtf-body"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "12px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Company website"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "8px"
      }
    }, /*#__PURE__*/React.createElement("input", {
      style: {
        ...inp,
        flex: 1
      },
      autoFocus: true,
      value: url,
      placeholder: "e.g. example.com",
      onChange: e => this.setState({
        url: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter") this.resolve();
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: this.resolve,
      disabled: !url.trim() || resolving
    }, resolving ? "Finding…" : "Find company"))), resolved ? /*#__PURE__*/React.createElement("div", {
      className: "caf-resolved"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        fontWeight: 600
      }
    }, resolved.name, " ", /*#__PURE__*/React.createElement("span", {
      className: "caf-pill"
    }, "found")), /*#__PURE__*/React.createElement("div", {
      className: "mtf-dim",
      style: {
        fontSize: "12px"
      }
    }, resolved.desc ? `${resolved.desc.slice(0, 110)} · ` : "", hostOf(this.state.url)))) : null, resolveFailed ? /*#__PURE__*/React.createElement("p", {
      className: "mtf-dim",
      style: {
        fontSize: "12px",
        margin: "0 0 12px",
        color: "#9a6b15"
      }
    }, "We could not look up this company. The report will use the name and website as entered.") : null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "12px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Company name ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        fontWeight: 400
      }
    }, resolved ? "(you can edit this)" : "")), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: company,
      onChange: e => this.setState({
        company: e.target.value
      })
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "12px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Focus markets ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        fontWeight: 400
      }
    }, "(optional: narrows the competitive read)")), /*#__PURE__*/React.createElement("div", null, marketChips.map(m => /*#__PURE__*/React.createElement("button", {
      key: m,
      className: "mtf-chip" + (markets.includes(m) ? " on" : ""),
      onClick: this.toggleMarket(m)
    }, markets.includes(m) ? `${m} ✕` : m)), /*#__PURE__*/React.createElement("input", {
      style: {
        ...inp,
        width: "180px",
        display: "inline-block",
        padding: "4px 10px",
        fontSize: "12px"
      },
      placeholder: "+ Add market\u2026",
      value: marketInput,
      onChange: e => this.setState({
        marketInput: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter" && marketInput.trim()) {
          this.setState({
            markets: [...markets, marketInput.trim()],
            marketInput: ""
          });
        }
      }
    }))), suggestions !== null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Suggested competitors ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        fontWeight: 400
      }
    }, "(optional: check to include them in the report)")), suggestions.length === 0 ? /*#__PURE__*/React.createElement("span", {
      className: "mtf-dim",
      style: {
        fontSize: "12px"
      }
    }, "Looking for similar companies\u2026") : suggestions.map((c, i) => /*#__PURE__*/React.createElement("button", {
      key: c.domain,
      className: "mtf-chip" + (c.checked ? " on" : ""),
      onClick: () => this.setState({
        suggestions: suggestions.map((x, j) => j === i ? {
          ...x,
          checked: !x.checked
        } : x)
      })
    }, c.checked ? `${c.domain} ✓` : c.domain))) : null), /*#__PURE__*/React.createElement("div", {
      className: "mtf-foot"
    }, /*#__PURE__*/React.createElement("span", {
      className: "mtf-dim",
      style: {
        fontSize: "11px"
      }
    }, "Takes 2 to 3 minutes. It appears in the list when ready."), /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "auto"
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        modal: false
      }),
      disabled: submitting
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: !url.trim() || !company.trim() || submitting,
      onClick: this.submit
    }, submitting ? "Starting…" : "Run analysis"))));
  }
  render() {
    const {
      rows,
      pill,
      search
    } = this.state;
    // Parsing each run's data blob is the costly part; redo it only when the rows change.
    if (!this._enriched || this._enriched.rows !== rows) {
      this._enriched = {
        rows,
        out: rows.map(r => {
          const done = isDone(r);
          const {
            cdr,
            sentiment
          } = done ? parseCompanyData(r.data) : {
            cdr: null,
            sentiment: null
          };
          return {
            r,
            id: rowId(r),
            done,
            cdr,
            sw: sentimentWords(sentiment),
            domain: hostOf(r.domain || "")
          };
        })
      };
    }
    const enriched = this._enriched.out;
    const yours = enriched.filter(x => x.r.subjectIsTenant);
    const pills = [{
      k: "all",
      label: "All",
      count: enriched.length
    }];
    if (yours.length && yours.length < enriched.length) {
      pills.push({
        k: "yours",
        label: "Yours",
        count: yours.length
      });
      pills.push({
        k: "others",
        label: "Competitors",
        count: enriched.length - yours.length
      });
    }
    const q = search.trim().toLowerCase();
    const list = enriched.filter(x => pill === "all" || (pill === "yours" ? x.r.subjectIsTenant : !x.r.subjectIsTenant)).filter(x => !q || `${x.r.company || ""} ${x.domain}`.toLowerCase().includes(q));
    const tableRows = list.map(x => {
      const failed = isFailed(x.r);
      const n = x.cdr ? realCompetitors(x.cdr).length : null;
      return {
        id: x.id,
        open: x.done ? () => this.props.history.push(`/Research/Company/Detail/${x.id}`) : null,
        cells: [/*#__PURE__*/React.createElement("span", {
          className: "apr-name"
        }, x.done ? /*#__PURE__*/React.createElement(Link, {
          to: `/Research/Company/Detail/${x.id}`
        }, /*#__PURE__*/React.createElement("b", null, x.r.company || x.domain)) : /*#__PURE__*/React.createElement("b", null, x.r.company || x.domain), x.domain ? /*#__PURE__*/React.createElement("span", {
          className: "apr-muted"
        }, x.domain) : null), x.done ? n === null ? /*#__PURE__*/React.createElement("span", {
          className: "apr-muted"
        }, "Not available") : n === 0 ? "None found" : `${n} competitor${n === 1 ? "" : "s"} found` : failed ? /*#__PURE__*/React.createElement("span", {
          className: "apr-muted"
        }, "Did not finish") : /*#__PURE__*/React.createElement("span", {
          className: "apr-muted"
        }, "Running, takes 2 to 3 minutes"), x.done ? x.sw ? x.sw.phrase : /*#__PURE__*/React.createElement("span", {
          className: "apr-muted"
        }, "Not enough mentions") : /*#__PURE__*/React.createElement(StatusChip, {
          row: x.r
        }), readableDate(x.r.createdDate)]
      };
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view apr-root"
    }, /*#__PURE__*/React.createElement("header", {
      className: "apr-hdr"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apr-hdr-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "apr-crumb"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/Apps"
    }, "Apps"), " \xB7 Company Analysis"), /*#__PURE__*/React.createElement("h1", null, "Company Analysis"), /*#__PURE__*/React.createElement("span", {
      className: "apr-sub"
    }, "A quick read on any company: what it sells, who it competes with and how visible it is online")), /*#__PURE__*/React.createElement("div", {
      className: "apr-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: () => this.setState({
        modal: true
      })
    }, "Analyze a company"))), this.renderRunStrip(), this.renderModal(), /*#__PURE__*/React.createElement(AprListCard, {
      pills: pills,
      pill: pill,
      onPill: k => this.setState({
        pill: k
      }),
      search: search,
      onSearch: v => this.setState({
        search: v
      }),
      placeholder: "Search companies",
      head: [{
        label: "Company"
      }, {
        label: "Competitors"
      }, {
        label: "How people talk about it"
      }, {
        label: "Analyzed"
      }],
      rows: tableRows,
      onDelete: this.onDelete,
      empty: rows.length ? "No companies match." : "No analyses yet. Use Analyze a company to run your first one."
    }));
  }
}
export class CompanyAnalysisViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }

  // The endpoint returns every run; the list searches, filters and pages
  // on the client.
  async fetchData() {
    var Service = ServiceFactory.getType('/company-analysis', 'research');
    var service = new Service();
    try {
      let data = await service.getAsync();
      this.data = Array.isArray(data) ? data : data && data.items || [];
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  CompanyAnalysisViewComponent
};